/**
 * Top Gun Landing: Audio, Callsign-Generator, Checkliste
 */
(function () {
  "use strict";

  function initFlightDeck() {
    var root = document.querySelector(".tg-flight-deck");
    if (!root) return;

    initAudio(root);
    initCallsign(root);
    initChecklist(root);
  }

  function initAudio(root) {
    var wrap = root.querySelector(".tg-audio-controls");
    if (!wrap) return;

    var audio = wrap.querySelector("#tg-background-audio");
    var toggle = wrap.querySelector("#tg-audio-toggle");
    var slider = wrap.querySelector("#tg-volume-slider");
    if (!audio || !toggle) return;

    var autoplayEnabled = wrap.getAttribute("data-autoplay") !== "false";
    var userInteracted = false;

    function setPlayingUI(playing) {
      if (playing) {
        toggle.classList.remove("muted");
      } else {
        toggle.classList.add("muted");
      }
    }

    function playAudio() {
      var p = audio.play();
      if (p && typeof p.then === "function") {
        p.then(function () {
          setPlayingUI(true);
        }).catch(function () {
          setPlayingUI(false);
        });
      }
    }

    function pauseAudio() {
      audio.pause();
      setPlayingUI(false);
    }

    toggle.addEventListener("click", function () {
      userInteracted = true;
      if (audio.paused) {
        playAudio();
      } else {
        pauseAudio();
      }
    });

    if (slider) {
      slider.addEventListener("input", function () {
        audio.volume = parseInt(slider.value, 10) / 100;
      });
      audio.volume = parseInt(slider.value, 10) / 100;
    }

    audio.addEventListener("error", function () {
      setPlayingUI(false);
    });

    if (autoplayEnabled) {
      var tryOnce = function () {
        if (userInteracted && audio.paused) {
          playAudio();
        }
      };
      setTimeout(tryOnce, 1500);
      document.addEventListener(
        "click",
        function onFirst() {
          userInteracted = true;
          tryOnce();
          document.removeEventListener("click", onFirst);
        },
        { once: true }
      );
    }
  }

  function initCallsign(root) {
    var btn = root.querySelector("[data-tg-callsign-generate]");
    var out = root.querySelector("[data-tg-callsign-output]");
    if (!btn || !out) return;

    var adjectives = [
      "Maverick",
      "Razor",
      "Viper",
      "Iceman",
      "Ghost",
      "Storm",
      "Thunder",
      "Sky",
      "Vector",
      "Bandit",
    ];
    var nouns = [
      "Fox",
      "Hawk",
      "Eagle",
      "Bolt",
      "Wolf",
      "Tiger",
      "Star",
      "Ace",
      "Ranger",
      "Strike",
    ];

    btn.addEventListener("click", function () {
      var a = adjectives[Math.floor(Math.random() * adjectives.length)];
      var b = nouns[Math.floor(Math.random() * nouns.length)];
      var n = Math.floor(Math.random() * 90) + 10;
      out.textContent = a + " " + b + " " + n;
    });
  }

  function fireConfetti() {
    var canvas = document.createElement("canvas");
    canvas.style.cssText =
      "position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:9999;";
    document.body.appendChild(canvas);

    var ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    var colors = ["#e8b84b", "#1b2a4a", "#c0392b", "#ffffff", "#f39c12"];
    var pieces = Array.from({ length: 120 }, function () {
      return {
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height * -0.5,
        w: Math.random() * 10 + 5,
        h: Math.random() * 6 + 3,
        color: colors[Math.floor(Math.random() * colors.length)],
        speed: Math.random() * 4 + 2,
        drift: (Math.random() - 0.5) * 2,
        rotation: Math.random() * Math.PI * 2,
        spin: (Math.random() - 0.5) * 0.2,
        opacity: 1,
      };
    });

    var start = null;
    var duration = 3200;

    function tick(ts) {
      if (!start) start = ts;
      var elapsed = ts - start;
      var progress = elapsed / duration;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      pieces.forEach(function (p) {
        p.y += p.speed;
        p.x += p.drift;
        p.rotation += p.spin;
        p.opacity = progress < 0.7 ? 1 : 1 - (progress - 0.7) / 0.3;

        ctx.save();
        ctx.globalAlpha = Math.max(0, p.opacity);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });

      if (elapsed < duration) {
        requestAnimationFrame(tick);
      } else {
        canvas.remove();
      }
    }

    requestAnimationFrame(tick);
  }

  function initChecklist(root) {
    var list = root.querySelector("[data-tg-checklist]");
    if (!list) return;

    var storageKey = list.getAttribute("data-storage-key") || "tg-flightcheck";
    var items = list.querySelectorAll('input[type="checkbox"]');
    var panel = list.closest(".tg-ready-check");
    var confettiFired = false;

    function checkAllDone(animate) {
      var total = items.length;
      if (total === 0) return;
      var done = Array.from(items).filter(function (i) { return i.checked; }).length;
      if (done === total) {
        if (panel) panel.classList.add("is-all-done");
        if (animate && !confettiFired) {
          confettiFired = true;
          fireConfetti();
        }
      } else {
        if (panel) panel.classList.remove("is-all-done");
        confettiFired = false;
      }
    }

    try {
      var saved = JSON.parse(localStorage.getItem(storageKey) || "{}");
      items.forEach(function (input, i) {
        var id = input.id || "tg-step-" + i;
        if (!input.id) input.id = id;
        if (saved[id]) {
          input.checked = true;
          var li = input.closest("li");
          if (li) li.classList.add("is-done");
        }
      });
    } catch (e) {
      /* ignore */
    }

    checkAllDone(false);

    items.forEach(function (input) {
      input.addEventListener("change", function () {
        var li = input.closest("li");
        if (li) {
          li.classList.toggle("is-done", input.checked);
        }
        try {
          var all = {};
          list.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
            if (inp.id) all[inp.id] = inp.checked;
          });
          localStorage.setItem(storageKey, JSON.stringify(all));
        } catch (e) {
          /* ignore */
        }
        checkAllDone(true);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFlightDeck);
  } else {
    initFlightDeck();
  }
})();
